<template>
    <router-link
        class="course__list_grid_item"
        :to="routeToCourse"
    >
        <div class="columns">
            <div class="column is-narrow">
                <div class="course__list_grid_item_image">
                    <template v-if="courseThumbnailUrl">
                        <component-image
                            :url="courseThumbnailUrl"
                            :alt="courseName"
                            :full-height="true"
                        ></component-image>
                    </template>
                    <template v-else>
                        <v-icon name="image"/>
                    </template>
                </div>
            </div>
            <div class="column">
                <div class="course__list_grid_item_content">
                    <h2 class="course__list_grid_item_content_title">{{courseName}}</h2>
                    <div class="course__list_grid_item_content_details">
                        <div class="course__list_grid_item_content_details_session">
                            <div class="columns is-vcentered is-variable is-2">
                                <template v-if="courseType === 'Digital learning' || courseType === 'Blended'">
                                    <div class="column is-narrow">
                                        <v-icon name="monitor"/>
                                    </div>
                                </template>
                                <template v-if="courseType === 'Event' || courseType === 'Blended'">
                                    <div class="column is-narrow">
                                        <v-icon name="calendar"/>
                                    </div>
                                </template>
                                <div class="column">
                                    {{courseType}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div :class="['course__list_grid_item_content_status']">
                        <component-status :status="routeQueryView === 'course-creator' ? courseStatus : courseEnrolmentStatus"/>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import api from '@/api'
import ComponentImage from '@/components/default/shared/ComponentImage'
import ComponentStatus from '@/components/default/shared/ComponentStatus'

export default {
  components: { ComponentStatus, ComponentImage },
  name: 'course-list-grid-item',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    courseThumbnailUrl () {
      if (this.item.file) {
        return `${api.files}/file/${this.item.file}`
      }
      return false
    },
    courseId () {
      return this.routeQueryView === 'course-creator' ? this.item.id : this.item.courseId
    },
    courseCatalogId () {
      return this.routeQueryView !== 'course-creator' ? this.item.id : undefined
    },
    courseVersionId () {
      return this.item.versionId
    },
    courseName () {
      return this.item.name
    },
    courseType () {
      return this.item.type
    },
    courseStatus () {
      return this.item.draft ? 'draft' : 'active'
    },
    courseEnrolmentStatus () {
      const latestEnrolmentState = this.item.latestEnrolment ? this.item.latestEnrolment.state : null
      const enrolmentStatus = this.item.enrolmentStatus

      return latestEnrolmentState || enrolmentStatus
    },
    courseNumberOfModules () {
      return this.item.moduleCount
    },
    routeQueryView () {
      return this.$route.query.view
    },
    routeToCourse () {
      let name
      let params
      if (this.routeQueryView === 'course-creator') {
        name = 'ebs-course-show'
        params = { id: this.courseId }
      } else {
        name = 'ebs-course-version-show'
        params = { courseId: this.courseId, versionId: this.courseVersionId, courseCatalogId: this.courseCatalogId }
      }
      return { name, params }
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courselistgriditem";
</style>
